import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';

import $ from 'jquery'
import Text from './canvas/text'
import MenuObject from './canvas/menu-object'
import util from './util'
import constants from './constants'
import designDomain from "./domain/designDomain";
import Interactable from "./canvas/interactable";

const getShapeData = ($element) => {
  if (!util.isShape($element)) return {};

  const shapeType = $element.attr('data-shape');
  const $path = shapeType === 'circle' ? $element.find('svg ellipse') :
                shapeType === 'square' ? $element.find('svg rect') :
                $element.find('svg line');
  const strokeColor = $path.attr('stroke');
  const fillType = $element.attr('data-fill-type') || 'solid';
  const fillColor = $element.attr('data-hex') || $path.attr('fill');
  const strokeWidth = $path.attr('data-original-stroke-width');

  let shapeWidth = 0;
  let shapeHeight = 0;

  if (shapeType === 'square') {
    shapeWidth = parseFloat($path.attr('width')) + 10;
    shapeHeight = parseFloat($path.attr('height')) + 10;
  } else if (shapeType === 'circle') {
    shapeWidth = parseFloat($path.attr('cx')) * 2;
    shapeHeight = parseFloat($path.attr('cy')) * 2;
  } else if (shapeType === 'line') {
    shapeWidth = parseFloat($path.attr('x2'));
  }

  return {
    strokeColor,
    strokeWidth: parseInt(strokeWidth),
    fillType,
    fillColor,
    shapeType,
    shapeWidth,
    shapeHeight
  }
};

function getBackground($element) {
  let opacity = $element.attr('data-bg-opacity') && !isNaN($element.attr('data-bg-opacity')) ? parseFloat($element.attr('data-bg-opacity')) : 1;
  let color = '#fff';

  return [color, opacity];
}

function getBorderBottom($element) {
  return [$element.attr('data-bb-color') || '#000000', $element.attr('data-bb-width') || 0]
}

const ACTIONS = {
  SELECT_ELEMENT: (state, {$element}) => {
    $('.dropdown-menu').removeClass('show');

    if ($element.hasClass('select')) {
      util.nextTick(() => {
        //Interactable.destroyAll();
        Interactable.deselectAll($element);
        Interactable.of($element).select();
      });
    } else {
      Interactable.deselectAll();
    }

    if (MenuObject.isMenuObject($element)) {
      return MenuObject.getSelectionState(state, $element);
    }

    const isSameElementSelected = !!state.$element && $element[0] === state.$element[0];
    const menuObjectItems = [];

    const isImage = util.isImage($element);
    const isVideoFrame = util.isVideoFrame($element);
    const isShape = util.isShape($element);
    const isLine = util.isLine($element);
    const isIllustration = util.isIllustration($element);
    const isFrame = util.isFrame($element);
    const isText = util.isText($element);
    const isQrCode = util.isQrCode($element);
    const isLocked = util.isLocked($element);
    const isHyperlink = util.isHyperlink($element);
    const isPage = util.isPage($element);

    const href = util.getHref($element);

    let backgroundColor = $element.css('background-color');
    if (backgroundColor.indexOf('rgb') > -1) backgroundColor = util.rgb2hex(backgroundColor);

    let borderRadius = 0;

    if (isImage) borderRadius = $element.find('img').attr('data-border-radius') || 0;
    else if (isVideoFrame) borderRadius = $element.find('video').attr('data-border-radius') || 0;
    else if (isFrame) borderRadius = parseInt($element.attr('data-border-radius') ? $element.attr('data-border-radius') : $element.css('borderTopLeftRadius') === '50%' ? '100' : $element.css('borderTopLeftRadius') || 0);
    else if (isText) borderRadius = parseInt($element.css('border-radius') || 0);
    else if (isShape) {
      if (util.isSquare($element)) borderRadius = $element.find('rect').attr('rx') || 0;
    }

    let [borderBottomColor, borderBottomWidth] = getBorderBottom($element);

    let borderWidth = 0;
    if (isImage || isQrCode) borderWidth = $element.find('img').attr('data-border-width') || 0;
    if (isFrame) borderWidth = $element.find('.img').attr('data-border-width') || 0;
    if (isVideoFrame) borderWidth = $element.find('video').attr('data-border-width') || 0;

    let borderColor = '#000000';
    if (isImage || isQrCode) borderColor = $element.find('img').css('borderColor') || $element.find('img').css('borderTopColor') || '#000000';
    if (isFrame) borderColor = $element.find('.img').css('borderColor') || $element.find('.img').css('borderTopColor') || '#000000';
    if (isVideoFrame) borderColor = $element.find('video').css('borderColor') || 0;
    if (borderColor.indexOf('rgb') > -1) borderColor = util.rgb2hex(borderColor);

    const isInGroup = $element.parents('.group').length > 0;

    const selectionType = $element.attr('data-component') || 'text';

    let view = 'text-plain';
    let subview = state.subview;
    if (isQrCode && !state.isMobileVersion) view = 'qr-codes';
    if (isFrame || isIllustration || isLine || isShape || isImage || isVideoFrame)  {
      view = 'graphics';
      if (state.view !== 'graphics') subview = 'root';
    }

    if (isPage) {
      view = state.view;

      if (state.view === 'print') {
        view = 'text';
      }
    }

    let illustrationConfig = {};
    if (selectionType === 'illustration') {
      const config = $element.attr('data-configuration');
      if (config) illustrationConfig = JSON.parse(config);
    }

    const data = getShapeData($element);
    let strokeColor = data.strokeColor || '#000000';
    if (strokeColor.indexOf('rgb') > -1) strokeColor = util.rgb2hex(strokeColor);
    let fillType = data.fillType || 'solid';
    let fillColor = data.fillColor || 'none';
    if (fillColor !== 'null' && fillColor.indexOf('rgb') > -1) fillColor = util.rgb2hex(fillColor);
    const shapeType = data.shapeType || 'line';

    const width = util.getWidth($element, state.designUnit);
    const height = util.getHeight($element, state.designUnit);

    const $elementContent = util.getElementContent($element);

    const transform = JSON.parse($element.attr('data-transform') || '{}');
    const rotationDeg = transform.rotationDeg || 0;
    const verticalFlip = transform.verticalFlip || false;
    const horizontalFlip = transform.horizontalFlip || false;
    const scale = transform.scale || 100;

    const textWrapped = $element.attr('data-text-wrapped') === "true";
    const curveValue = $element.attr('data-curve-value') || '0';

    const textShadowed = $element.attr('data-text-shadowed') === "true";
    const textShadowOffset = $element.attr('data-shadow-offset') || 5;
    const textShadowDirection = $element.attr('data-shadow-direction') || -45;
    const textShadowBlur = $element.attr('data-shadow-blur') || 0;
    const textShadowOpacity = $element.attr('data-shadow-opacity') || 40;
    const textShadowColor = $element.attr('data-shadow-color') || '';

    let isAnimated = false;
    if (isIllustration || isText || isFrame || isShape) {
      isAnimated = $element.find('.ani-wrapper').length > 0;
    }

    const baseAnimation = $element.attr('data-base-animation');
    const addOnAnimation = $element.attr('data-addon-animation');
    const baseSpeed = parseFloat($element.attr('data-base-anim-speed')) || 0;
    const addOnSpeed = parseFloat($element.attr('data-addon-anim-speed')) || 0;
    const baseDuration = parseFloat($element.attr('data-base-anim-duration')) || 20;
    const animationStartOrEnd = $element.attr('data-anim-start-end') || 'start';

    const preserveRatio = $element.attr('data-preserve-ratio') ? $element.attr('data-preserve-ratio') === 'true' : true;
    let opacity = ($elementContent.css('opacity') || $element.attr('data-opacity')) * 100;
    if (isShape) opacity = ($element.attr('data-opacity') || $elementContent.css('opacity')) * 100;
    const inlineState = Text.getInlineStyles($element, state, isSameElementSelected);

    const brightness = util.getElementBrightness($elementContent);
    const contrast = util.getElementContrast($elementContent);
    const vibrance = util.getElementVibrance($elementContent);
    const saturation = util.getElementSaturation($elementContent);
    const blur = util.getElementBlur($elementContent);
    const grayscale = util.getElementGrayscale($elementContent);
    const sepia = util.getElementSepia($elementContent);
    const invert = util.getElementInvert($elementContent);
    const muted = util.getElementMuted($elementContent.find('video'));
    const animation = util.getElementAnimation($elementContent);

    const [bgColor, bgOpacity] = getBackground($element);

    return {
      ...state,
      ...inlineState,

      hasSelection: true,
      isMultiSelect: false,
      multiSelectType: 'none',
      $element,
      $elements: [$element],
      opacity,
      brightness,
      contrast,
      vibrance,
      saturation,
      blur,
      grayscale,
      sepia,
      invert,
      muted,
      animation,
      backgroundColor,
      borderRadius,
      borderColor,
      borderWidth,
      width,
      height,
      selectionType,
      isInGroup,
      illustrationConfig,
      strokeColor,
      strokeWidth: data.strokeWidth,
      fillType,
      fillColor,
      shapeType,
      rotationDeg,
      verticalFlip,
      horizontalFlip,
      scale,
      textWrapped,
      curveValue,
      textShadowed,
      textShadowOffset,
      textShadowDirection,
      textShadowBlur,
      textShadowOpacity,
      textShadowColor,
      isAnimated,
      baseAnimation,
      addOnAnimation,
      baseSpeed,
      addOnSpeed,
      baseDuration,
      animationStartOrEnd,
      selectedMultiAligned: '',
      isFrame,
      isImage,
      isVideoFrame,
      isShape,
      isLine,
      isIllustration,
      preserveRatio,
      isLocked,
      isHyperlink,
      href,
      bgColor,
      bgOpacity,
      borderBottomColor,
      borderBottomWidth,
      menuObjectItems,
      view,
      subview,
      iniFrame: util.iniFrame(),
      hasVideo: util.hasVideo(),
      hasAnimation: util.hasAnimation()
    }
  },

  SET_PRESERVE_RATIO: (state, {preserve}) => ({
    ...state,
    preserveRatio: preserve
  }),

  MULTI_SELECT_ELEMENT: (state, {$element}) => {
    const $elements = [...state.$elements, $element];

    //Interactable.destroyAll();
    Interactable.deselectAll($element);

    util.nextTick(() => {
      $elements.forEach($el => {
        if ($el.hasClass('select')) {
          Interactable.of($el).select();
        }
      });
    });

    return {
      ...state,
      isMultiSelect: true,
      $elements,
      multiSelectType: util.getMultiSelectType($elements)
    }
  },

  MULTI_DESELECT_ELEMENT: (state, {$element}) => {
    const $elements = state.$elements.filter((it) => it.attr('id') !== $element.attr('id'));

    Interactable.getIfExists($element)?.deselect();

    return {
      ...state,
      $elements,
      multiSelectType: util.getMultiSelectType($elements)
    }
  },

  DESELECT_ELEMENT: (state) => {
    state.$elements.forEach($el => {
      Interactable.getIfExists($el)?.deselect();
    });
    return {
      ...state,
      hasSelection: false,
      isMultiSelect: false,
      multiSelectType: 'none',
      href: '',
      isHyperlink: '',
      $element: null,
      $elements: []
    }
  },

  UPDATE_ELEMENT_ATTRIBUTE: (state, {key, value}) => ({
    ...state,
    [key]: value
  }),

  UPDATE_CTRL_PRESSED: (state, {pressed}) => ({
    ...state,
    isCtrlPressed: pressed
  }),

  UPDATE_SHIFT_PRESSED: (state, {pressed}) => ({
    ...state,
    isShiftPressed: pressed
  }),

  UPDATE_ZOOM: (state, {zoom}) => ({
    ...state,
    zoom
  }),

  SET_MIN_ZOOM: (state, {minZoom}) => ({
    ...state,
    minZoom
  }),

  SET_MAX_ZOOM: (state, {maxZoom}) => ({
    ...state,
    maxZoom
  }),

  SET_ZOOM_ADJUSTED: (state, {zoomAdjusted}) => ({
    ...state,
    zoomAdjusted
  }),

  GO_TO_VIEW: (state, {view}) => ({
    ...state,
    view
  }),

  GO_TO_SUBVIEW: (state, {subview}) => ({
    ...state,
    subview
  }),

  SET_DESIGN: (state, {design}) => {
    return {
      ...state,
      designId: design.id,
      designName: design.name,
      designSize: design.size,
      designUnit: design.size === 'custom' ? design.unit : util.getDesignUnit(design.size),
      designCustomWidth: design.width + (design.unit === 'in' ? 0.25 : 0),
      designCustomHeight: design.height + (design.unit === 'in' ? 0.25 : 0),
      designStatus: design.status,
      designFolders: design.folders,
      isCustomSize: util.isCustomSize(design.size),
      isTemplate: design.type === 'template',
      isSocialDesign: util.isSocialDesign(design.size),
      isBusinessCard: util.isBusinessCard(design.size),
      isLoyaltyCard: util.isLoyaltyCard(design.size),
      isCommentCard: util.isCommentCard(design.size),
      isRackCard: util.isRackCard(design.size),
      isGiftCertificate: util.isGiftCertificate(design.size),
      isTakeout: util.isTakeout(design.size),
      isFoldedMenu: util.isFoldedMenu(design.size),
      isHalfPageMenu: util.isHalfPageMenu(design.size),
      isTableTent: util.isTableTent(design.size),
      isTableTentInsert: util.isTableTentInsert(design.size),
      isPoster: util.isPoster(design.size),
      isDigitalMenuBoard: util.isDigitalMenuBoard(design.size),
      isSticker: util.isSticker(design.size),
      isLabel: util.isLabel(design.size),
      isSandwichBoard: util.isSandwichBoard(design.size),
      isLogo: util.isLogo(design.size),
      isPixelDesign: util.isPixelDesign(),
      hasChanges: design.hasChanges,
      lastSavedTag: design.lastSavedTag,
      templateId: design.templateId,
      free: design.free,
      locationId: design.locationId,
      posAutoSyncEnabled: design.posUpdatedEnabled != null ? design.posUpdatedEnabled : true,
      dsaAutoSyncEnabled: design.dsaUpdatedEnabled != null ? design.dsaUpdatedEnabled : true,
      linksAutoSyncEnabled: design.linksUpdatedEnabled != null ? design.linksUpdatedEnabled : true,
      hasVideo: util.hasVideo(),
      hasAnimation: util.hasAnimation()
    }
  },

  MARK_AS_MODIFIED: (state) => {
    return {
      ...state,
      hasChanges: true
    }
  },

  SET_DESIGN_ID: (state, {id}) => ({
    ...state,
    designId: id
  }),

  SET_IS_TEMPLATE_LINK: (state, {isTemplateLink}) => ({
    ...state,
    isTemplateLink
  }),

  SET_LOCATION_ID: (state, {id}) => ({
    ...state,
    locationId: id
  }),

  SET_BRAND: (state, {brand}) => ({
    ...state,
    brand: brand
  }),

  SET_IS_TEMPLATE: (state, {isTemplate}) => ({
    ...state,
    isTemplate
  }),

  SET_DESIGN_FOLDERS: (state, {folders}) => ({ ...state, designFolders: folders }),

  SET_DESIGN_NAME: (state, {name}) => ({...state, designName: name}),

  SET_DESIGN_SIZE: (state, {size}) => ({
    ...state,
    designSize: size?.key,
    designUnit: size?.key === 'custom' ? size?.unit : util.getDesignUnit(size?.key),
    designCustomWidth: size?.width,
    designCustomHeight: size?.height,
    isSocialDesign: util.isSocialDesign(size?.key),
    isBusinessCard: util.isBusinessCard(size?.key),
    isLoyaltyCard: util.isLoyaltyCard(size?.key),
    isCommentCard: util.isCommentCard(size?.key),
    isRackCard: util.isRackCard(size?.key),
    isGiftCertificate: util.isGiftCertificate(size?.key),
    isTakeout: util.isTakeout(size?.key),
    isFoldedMenu: util.isFoldedMenu(size?.key),
    isFacebookPost: util.isFacebookPost(size?.key),
    isFacebookStory: util.isFacebookStory(size?.key),
    isInstagramPost: util.isInstagramPost(size?.key),
    isInstagramStory: util.isInstagramStory(size?.key),
    isHalfPageMenu: util.isHalfPageMenu(size?.key),
    isTableTent: util.isTableTent(size?.key),
    isTableTentInsert: util.isTableTentInsert(size?.key),
    isPoster: util.isPoster(size?.key),
    isDigitalMenuBoard: util.isDigitalMenuBoard(size?.key),
    isSticker: util.isSticker(size?.key),
    isLabel: util.isLabel(size?.key),
    isSandwichBoard: util.isSandwichBoard(size?.key),
    isCustomSize: util.isCustomSize(size?.key),
    isLogo: util.isLogo(size?.key),
    isPixelDesign: util.isPixelDesign(),
  }),

  SET_DESIGN_STATUS: (state, {status}) => ({...state, designStatus: status}),

  UPDATE_DESIGN_COLORS: (state, {colors}) => ({...state, designColors: colors}),
  UPDATE_DESIGN_FONTS: (state, {fonts}) => ({...state, designFonts: fonts}),

  SHOW_PROMOS: (state) => ({...state, isPromosVisible: true}),
  HIDE_PROMOS: (state) => ({...state, isPromosVisible: false}),

  SET_PROMO_LOADING: (state, {isLoading}) => ({...state, promoDesignsLoading: isLoading}),
  SET_PROMO_DESIGNS: (state, {designs, isLoading}) => ({...state, promoDesigns: designs, promoDesignsLoading: isLoading}),

  SHOW_COLLECTIONS: (state, {show}) => ({...state, isCollectionModal: show}),

  SET_PUBLIC_PROMO_DESIGNS: (state, {designs, isLoading}) => ({
    ...state,
    publicPromoDesigns: designs,
    promoDesignsLoading: isLoading
  }),

  SET_TEMPLATE_GROUPS: (state, {groups, isLoading}) => {
    groups.forEach(entry => {
      entry.designs = entry.designs.map(it => new designDomain.Design(it, util.sizes))
    });
    return {
      ...state,
      templateGroups: groups,
      promoDesignsLoading: isLoading
    }
  },

  SET_TEMPLATE_FAMILIES: (state, {families, isLoading}) => {
    families.forEach(entry => {
      entry.designs = entry.designs.map(it => new designDomain.Design(it, util.sizes))
    });
    return {
      ...state,
      templateFamilies: families,
      promoDesignsLoading: isLoading
    }
  },

  SET_TEMPLATE_VIEW: (state, {view}) => ({
    ...state,
    templateView: view
  }),

  SET_SELECTED_FAMILY: (state, {family}) => ({
    ...state,
    selectedFamily: family
  }),

  SET_SELECTED_COLLECTION: (state, {collection}) => ({
    ...state,
    selectedCollection: collection
  }),
  SET_SELECTED_CATEGORY: (state, {category}) => ({
    ...state,
    selectedCategory: category
  }),

  SET_RULER_VISIBILITY: (state, {isVisible}) => ({...state, isRulerVisible: isVisible}),

  SET_HISTORY_NEXT: (state, {has}) => ({...state, hasHistoryNext: has}),
  SET_HISTORY_PREV: (state, {has}) => ({...state, hasHistoryPrev: has}),

  FLIP_VERTICALLY: (state) => {
    const newFlip = !state.verticalFlip;
    return {...state, verticalFlip: newFlip}
  },
  FLIP_HORIZONTALLY: (state) => ({...state, horizontalFlip: !state.horizontalFlip}),

  SET_VERSION_PREVIEW: (state, {isVersionPreview, revision}) => ({
    ...state,
    isVersionPreview,
    previewId: revision ? revision.id : '',
    revisionLabel: revision ? revision.label : ''
  }),

  SET_BUCKET_COUNT: (state, {counts}) => ({
    ...state,
    draftCount: counts.draft || 0,
    submittedCount: counts.submitted || 0,
    profileCount: counts.profile || 0,
    reviewCount: counts.reviewed || 0,
    rejectedCount: counts.rejected || 0,
    publishedCount: counts.published || 0,
    samplecopyCount: counts.samplecopy || 0,
    restorehardCount: counts.restoreHard || 0,
    restoreeasyCount: counts.restoreEasy || 0
  }),

  SET_IMPORT_WEBSITE_MODAL: (state, {modal}) => ({
    ...state,
    isImportWebsiteModal: modal
  }),

  SHOW_AUTH_OVERLAY: (state) => ({
    ...state,
    isAuthOverlay: true
  }),

  HIDE_AUTH_OVERLAY: (state) => ({
    ...state,
    isAuthOverlay: false
  }),

  SHOW_CONFIGURE_TEMPLATE_MODAL: (state) => ({
    ...state,
    isConfigureTemplateModal: true
  }),

  HIDE_CONFIGURE_TEMPLATE_MODAL: (state) => ({
    ...state,
    isConfigureTemplateModal: false
  }),

  SHOW_MOVE_COPY_TEMPLATE_MODAL: (state) => ({
    ...state,
    isMoveCopyTemplateModal: true
  }),

  HIDE_MOVE_COPY_TEMPLATE_MODAL: (state) => ({
    ...state,
    isMoveCopyTemplateModal: false
  }),

  SHOW_SHARING_MODAL: (state) => ({
    ...state,
    isSharingModal: true
  }),

  HIDE_SHARING_MODAL: (state) => ({
    ...state,
    isSharingModal: false
  }),

  SHOW_FIX_IMAGE_MODAL: (state, {path}) => ({
    ...state,
    isFixImageModal: true,
    fixImagePath: path,
  }),

  HIDE_FIX_IMAGE_MODAL: (state) => ({
    ...state,
    isFixImageModal: false
  }),

  SHOW_CONFIGURE_ILLUSTRATION_MODAL: (state) => ({
    ...state,
    isConfigureIllustrationModal: true
  }),

  HIDE_CONFIGURE_ILLUSTRATION_MODAL: (state) => ({
    ...state,
    isConfigureIllustrationModal: false
  }),

  SHOW_CONFIGURE_FREE_IMAGE_MODAL: (state) => ({
    ...state,
    isConfigureFreeImageModal: true
  }),

  HIDE_CONFIGURE_FREE_IMAGE_MODAL: (state) => ({
    ...state,
    isConfigureFreeImageModal: false
  }),

  SHOW_MENU_CONTENT_MODAL: (state, {items}) => ({
    ...state,
    menuObjectItems: items || [],
    isMenuContentModal: true
  }),

  HIDE_MENU_CONTENT_MODAL: (state) => ({
    ...state,
    isMenuContentModal: false
  }),

  SHOW_ORGANIZE_UPLOADS_MODAL: (state) => ({
    ...state,
    isOrganizeUploadsModal: true
  }),

  HIDE_ORGANIZE_UPLOADS_MODAL: (state) => ({
    ...state,
    isOrganizeUploadsModal: false
  }),

  LOGIN: (state, {member}) => ({
    ...state,
    isLogged: true,
    isDesigner: member.isDesigner,
    isAdmin: member.isAdmin,
    isWriter: member.isWriter,
    memberId: member.id,
    memberName: member.ownerName,
    memberCountry: member.country,
    locationId: member.locationId,
    hasPdfPermission: member.status === constants.MEMBER_ACTIVE,
    isFreemium: member.status !== constants.MEMBER_ACTIVE,
    hasPrintingPermission: member.printing,
    hasDownloadsPermission: member.downloads,
    hasTemplatesPermission: true
  }),

  DOWNLOAD_WITH_BLEEDS: (state, {bleeds}) => ({
    ...state,
    downloadPdfWithBleeds: bleeds
  }),


  SET_AUTH_OVERLAY_VIEW: (state, {view}) => ({
    ...state,
    authOverlayView: view
  }),

  SET_AUTH_OVERLAY_EXIT: (state, {exit}) => ({
    ...state,
    authOverlayExit: exit
  }),

  SET_LAST_UPDATE: (state, {stamp}) => ({
    ...state,
    lastUpdate: stamp
  }),

  SET_LAST_SAVED: (state, {stamp}) => ({
    ...state,
    lastSaved: stamp
  }),

  SET_ACTIVE_MEMBER: (state) => ({
    ...state,
    hasPdfPermission: true,
    isFreemium: false,
    memberCountry: $('#payCountry').val()
  }),

  SET_STATUS_FILTER: (state, {status}) => ({...state, statusFilter: status}),

  SET_IS_SAVING: (state, {isSaving}) => ({
    ...state, isSaving
  }),

  SET_IS_SAVED: (state, {isSaved}) => ({
    ...state, isSaved
  }),

  SET_IS_MOCK_DATA: (state, {isMockData}) => {
    return {
      ...state, isMockData
    }
  },

  DISABLE_TEXT_HIGHLIGHT: (state) => ({
    ...state,
    selectionIndex: 0,
    selectionLength: 0,
    isTextHighlight: false,
  }),


  SET_IS_TEXT_HIGHLIGHT: (state, {$element, range, format}) => {
    const isTextHighlight = !!range && range.length > 0;
    const index = range ? range.index : 0;
    const length = range ? range.length : 0;

    let font = null;
    if (state.fontFamilyKey) {
      font = util.getFont(state.fontFamilyKey);
    }
    const lastValidSelection = {
      fontSize: state.fontSize,
      color: state.color,
      isBold: state.isBold,
      isItalic: state.isItalic,
      isUnderline: state.isUnderline,
      fontFamily: font !== null ? font.font : '',
      isUppercase: state.isUppercase,
      letterSpacing: state.letterSpacing,
      lineHeight: state.lineHeight,
      textAlign: state.textAlign
    };

    let color = Array.isArray(format.color) ? format.color[0] : format.color;
    if ((!color || color === constants.DEFAULT_TEXT_COLOR) && $element) color = $element.css('color');

    let fontFamily = Array.isArray(format.blockFont) ? format.blockFont[0] : format.blockFont;
    let fontSize = Array.isArray(format.blockSize) ? format.blockSize[0] : format.blockSize;
    let fontFamilyKey = '';

    fontFamily = fontFamily ? fontFamily.replace(/\"/g, '') : '';
    fontSize = util.convertInlineSize(parseInt(fontSize));

    if (fontFamily) {
      const font = util.getFontByFamily(fontFamily);
      fontFamilyKey = font.key;
      fontFamily = font.label
    }

    const isBold = Array.isArray(format.bold) ? format.bold[0] === true : format.bold === true;
    const isItalic = Array.isArray(format.italic) ? format.italic[0] === true : format.italic === true;
    const isUnderline = Array.isArray(format.underline) ? format.underline[0] === true : format.underline === true;
    const isUppercase = Array.isArray(format.case)
      ? (format.case[0] === true || format.case[0] === 'up') : (format.case === true || format.case === 'up');
    const letterSpacing = util.formatLetterSpacing(
      Array.isArray(format.letterSpacing) ? format.letterSpacing[0] : format.letterSpacing
    );

    const lineHeight = parseFloat(format.blockLineHeight || 1) * 10;
    const textAlign = format.blockTextAlign || 'left';

    return {
      ...state,
      selectionIndex: index,
      selectionLength: length,
      isTextHighlight,
      fontSize,
      color,
      isBold,
      isItalic,
      isUnderline,
      fontFamilyKey,
      fontFamily,
      isUppercase,
      letterSpacing,
      lastValidSelection,
      lineHeight,
      textAlign
    };
  },

  SET_SHOW_EXIT_WARNING: (state, {show}) => ({
    ...state,
    showExitWarning: show
  }),

  SET_MENU_OBJECT_ITEMS: (state, {menuObjectItems}) => {
    return ({
      ...state,
      menuObjectItems
    })
  },

  SET_IS_MENU_OBJECT_COPIED: (state, {isMenuObjectCopied}) => {
    return ({
      ...state,
      isMenuObjectCopied
    })
  },

  SET_MENU_GROUPS: (state, {menuGroups}) => {
    return ({
      ...state,
      menuGroups
    })
  },

  SET_MENU_GROUPS_SOURCE: (state, {menuGroupsSource}) => {
    return ({
      ...state,
      menuGroupsSource
    })
  },

  SET_MENU_GROUPS_SOURCE_IN_PROGRESS: (state, {menuGroupsSourceInProgress}) => {
    return ({
      ...state,
      menuGroupsSourceInProgress
    })
  },

  APPLY_TO_MO_IN_PROGRESS: (state, {applyToMoInProgress}) => {
    return ({
      ...state,
      applyToMoInProgress
    })
  },

  SET_SQUARE_LOADING: (state, {squareLoading}) => ({
    ...state,
    squareLoading
  }),

  SET_SQUARE_SELECT: (state, {squareSelect}) => ({
    ...state,
    squareSelect
  }),

  SET_MENU_OBJECT_STYLES: (state, {menuObjectStyles}) => ({
    ...state,
    menuObjectStyles
  }),

  SET_MENU_OBJECT_DOTS: (state, {menuObjectDots}) => ({
    ...state,
    menuObjectDots
  }),

  SET_MENU_OBJECT_LAYOUT: (state, {menuObjectLayout}) => ({
    ...state,
    menuObjectLayout
  }),

  SET_ICON_LAYOUT: (state, {iconLayout}) => ({
    ...state,
    iconLayout
  }),

  SET_ICONS_IN_DESCRIPTION: (state, {iconsInDescription}) => ({
    ...state,
    iconsInDescription
  }),

  SET_ICON_POSITION: (state, {iconPosition}) => ({
    ...state,
    iconPosition
  }),

  SET_SHOW_MENU_TAG: (state, {showMenuTag}) => ({
    ...state,
    showMenuTag
  }),

  SET_SHOW_MODIFIERS: (state, {showModifiers}) => ({
    ...state,
    showModifiers
  }),

  SET_MODIFIER_LAYOUT: (state, {modifierLayout}) => ({
    ...state,
    modifierLayout
  }),

  SET_MODIFIER_DIVIDER: (state, {modifierDivider}) => ({
    ...state,
    modifierDivider
  }),

  SET_HIDE_PRICES: (state, {hidePrices}) => ({
    ...state,
    hidePrices
  }),

  SET_HIDE_TRAILING_ZEROES: (state, {hideTrailingZeroes}) => ({
    ...state,
    hideTrailingZeroes
  }),

  SET_INLINE_EXTRAS: (state, {inlineExtras}) => ({
    ...state,
    inlineExtras
  }),

  SET_MENU_TAG_LAYOUT: (state, {menuTagLayout}) => ({
    ...state,
    menuTagLayout
  }),

  SET_PRICE_DIVIDER: (state, {priceDivider}) => ({
    ...state,
    priceDivider
  }),

  SET_PRICE_BORDER: (state, {priceBorder}) => ({
    ...state,
    priceBorder
  }),

  SET_MENU_OBJECT_IMPORT_LOCATION: (state, {id}) => ({
    ...state,
    menuObjectImportLocation: id
  }),

  SET_MENU_OBJECT_IMPORT_DESIGN: (state, {id}) => ({
    ...state,
    menuObjectImportDesign: id
  }),

  SET_MENU_OBJECT_IMPORT_NAME: (state, {name}) => ({
    ...state,
    menuObjectImportName: name
  }),

  SET_ONLINE_MENU_IMPORT: (state, {menu}) => ({
    ...state,
    onlineMenuImport: menu
  }),

  SET_IS_DESIGN_LOADING: (state, {loading}) => ({
    ...state,
    isDesignLoading: loading
  }),

  SET_WEBSITE_TOKEN: (state, {websiteToken}) => ({
    ...state,
    websiteToken: websiteToken
  }),

  SET_SHARE_LINK: (state, {shareLink}) => ({
    ...state,
    shareLink: shareLink
  }),

  SET_IN_SYNC: (state, {inSync}) => ({
    ...state,
    inSync: inSync
  }),

  SET_IS_SYNCING: (state, {isSyncing}) => ({
    ...state,
    isSyncing: isSyncing
  }),

  SET_IS_SYNCING_QR: (state, {isSyncingQR}) => ({
    ...state,
    isSyncingQR: isSyncingQR
  }),

  SET_MOBILE_VERSION: (state, {isMobileVersion}) => ({
    ...state,
    isMobileVersion: isMobileVersion
  }),

  SET_IN_IFRAME: (state, {iniFrame}) => ({
    ...state,
    iniFrame: iniFrame
  }),

  SET_REPLACE_FRAME_MODE: (state, {isReplaceFrameMode}) => ({
    ...state,
    isReplaceFrameMode: isReplaceFrameMode
  }),

  SET_SELECTION_TYPE: (state, {selectionType}) => ({
    ...state,
    selectionType: selectionType,
  }),

  SET_VIEW: (state, {view}) => ({
    ...state,
    view: view,
  }),

  SET_IS_LEFT_MENU_VISIBLE: (state, {isLeftMenuVisible}) => ({
    ...state,
    isLeftMenuVisible
  }),

  UPDATE_PRINT_ADVISOR: (state, {printAdvisor}) => ({
    ...state,
    printAdvisor: printAdvisor
  }),

  SHOW_LAYOUT_GUIDE_BAR: (state, {isLayoutGuideToggled}) => ({
    ...state,
    isLayoutGuideToggled: isLayoutGuideToggled,
    hasSelection: true,
  }),

  SHOW_SAFETY_ZONE: (state, {isSafetyZoneToggled}) => ({
    ...state,
    isSafetyZoneToggled
  }),


  SHOW_LAYOUT_GUIDE_PROPS: (state, {layoutGuide, layoutGuidePageMargin, layoutGuideColumnMargin}) => ({
    ...state,
    layoutGuide,
    layoutGuidePageMargin,
    layoutGuideColumnMargin
  }),

  SET_LAYOUT_GUIDE: (state, {layoutGuide}) => ({
    ...state,
    layoutGuide,
  }),

  SET_LAYOUT_GUIDE_PAGE_MARGIN: (state, {layoutGuidePageMargin}) => ({
    ...state,
    layoutGuidePageMargin,
  }),

  SET_LAYOUT_GUIDE_COLUMN_MARGIN: (state, {layoutGuideColumnMargin}) => ({
    ...state,
    layoutGuideColumnMargin,
  }),

  SET_IS_NEW_DESIGN: (state, {isNewDesign}) => ({
    ...state,
    isNewDesign
  }),

  SET_IS_ITEM_LIBRARY_MODAL: (state, {isItemLibraryModal}) => ({
    ...state,
    isItemLibraryModal
  }),


  SET_ITEM_LIBRARY_DEFAULT_VIEW: (state, {itemLibraryDefaultView}) => ({
    ...state,
    itemLibraryDefaultView
  }),

  SET_IS_DATA_LIBRARY_MODAL: (state, {isDataLibraryModal}) => ({
    ...state,
    isDataLibraryModal
  }),

  SET_IS_MO_EDIT_MODAL: (state, {isMOEditModal}) => ({
    ...state,
    isMOEditModal
  }),

  SET_MO_EDIT_MODE: (state, {MOEditMode}) => ({
    ...state,
    MOEditMode
  }),

  SET_MO_SELECTED_ITEM_IDX: (state, {moSelectedItemIdx}) => ({
    ...state,
    moSelectedItemIdx
  }),

  SET_MO_LAST_SORT_DATE: (state, {moLastSortDate}) => ({
    ...state,
    moLastSortDate
  }),

  SET_IS_POS_CONNECT_MODAL: (state, {isPosConnectModal}) => ({
    ...state,
    isPosConnectModal
  }),

  SET_IS_MMG_TOUR_MODAL: (state, {isMMGTourModal}) => ({
    ...state,
    isMMGTourModal
  }),

  SET_IS_POS_TOUR_MODAL: (state, {isPOSTourModal}) => ({
    ...state,
    isPOSTourModal
  }),

  SET_IS_APP_LOADING: (state, {isAppLoading, appLoadingInfo}) => ({
    ...state,
    isAppLoading,
    appLoadingInfo
  }),

  SET_COLOR_PICKER_TYPE: (state, {colorPickerType}) => ({
    ...state,
    colorPickerType
  }),

  SET_PREV_ASIDE_VIEW: (state, {prevAsideView}) => ({
    ...state,
    prevAsideView
  }),

  SET_IS_QR_DESIGN_MODE: (state, {isQRDesignMode}) => ({
    ...state,
    isQRDesignMode
  }),

  SET_IS_ADD_QR_MODE: (state, {isAddQRMode}) => ({
    ...state,
    isAddQRMode
  }),

  SET_PRINT_PAPER_TYPE: (state, {printPaperType}) => ({
    ...state,
    printPaperType
  }),

  SET_PRINT_PAGINATION: (state, {printPagination}) => ({
    ...state,
    printPagination
  }),

  SET_PRINT_QUANTITY: (state, {printQuantity}) => ({
    ...state,
    printQuantity
  }),

  SET_POS_DATA: (state, {posFeature, toastEmail, isClover, isSquare, isTreez, isPopmenu}) => ({
    ...state,
    posFeature,
    toastEmail,
    isClover,
    isSquare,
    isTreez,
    isPopmenu
  }),

  SET_MENU_ACTIVE_ICONS: (state, {menuActiveIcons}) => ({
    ...state,
    menuActiveIcons,
  }),

  SET_POS_AUTO_SYNC_ENABLED: (state, {posAutoSyncEnabled}) => ({
    ...state,
    posAutoSyncEnabled,
  }),

  SET_DSA_AUTO_SYNC_ENABLED: (state, {dsaAutoSyncEnabled}) => ({
    ...state,
    dsaAutoSyncEnabled,
  }),

  SET_LINKS_AUTO_SYNC_ENABLED: (state, {linksAutoSyncEnabled}) => ({
    ...state,
    linksAutoSyncEnabled,
  }),

  SET_HAS_POS_DATA: (state, {hasPosData}) => ({
    ...state,
    hasPosData,
  }),

  SET_POS_SYNC_PENDING_COUNT: (state, {posSyncPendingCount}) => ({
    ...state,
    posSyncPendingCount,
  }),

  IS_DSA_DESIGN: (state, {isDSADesign}) => ({
    ...state,
    isDSADesign
  }),

  MAIN_NOTIFICATION_MESSAGE: (state, {mainNotificationMessage}) => ({
    ...state,
    mainNotificationMessage
  }),

  IS_MOBILE_ASIDE: (state, {isMobileAside}) => ({
    ...state,
    isMobileAside
  }),

  IS_VIEW_ALL_PAGES: (state, {isViewAllPages}) => ({
    ...state,
    isViewAllPages
  }),

  IS_MOBILE_BOTTOM_NAV: (state, {isMobileBottomNav}) => ({
    ...state,
    isMobileBottomNav
  }),

  IS_ALT_TEXT_MODAL: (state, {isAltTextModal}) => ({
    ...state,
    isAltTextModal
  }),

  SELECTED_UPLOADED_IMAGE: (state, {selectedUploadedImage}) => ({
    ...state,
    selectedUploadedImage
  }),

  SELECTED_UPLOADED_ICON: (state, {selectedUploadedIcon}) => ({
    ...state,
    selectedUploadedIcon
  }),

  IS_JUST_UPLOADED: (state, {isJustUploaded}) => ({
    ...state,
    isJustUploaded
  }),

  LAST_SELECTED_HIGHLIGHT_ID: (state, {lastSelectedHighlightId}) => ({
    ...state,
    lastSelectedHighlightId
  }),
  
  SET_FAVORITE_ASSETS: (state, {favoriteAssets}) => ({
    ...state,
    favoriteAssets
  }),
};

const INITIAL = {
  appLoadingInfo: "Preparing your design...",
  isAppLoading: true,

  isLogged: false,
  isDesigner: false,
  isAdmin: false,
  isWriter: false,

  hasPrintingPermission: false,
  hasDownloadsPermission: false,
  hasTemplatesPermission: false,

  isSaving: false,
  isSaved: false,
  isNewDesign: false,

  isTemplate: false,
  isMockData: false,

  memberId: '',
  visitorId: '',
  locationId: '',
  memberName: '',
  memberCountry: '',
  hasPdfPermission: false,
  isFreemium: true,
  brand: {},

  designId: window.data.design.id,
  parentId: window.data.design.parentId,
  templateId: '',
  classicId: window.data.design.classicId,
  importStyles: window.data.design.importStyles,
  importSize: window.data.design.importSize,
  importName: window.data.design.importName,
  importAccount: window.data.design.importAccount,

  layoutGuide: 0,
  layoutGuidePageMargin: .25,
  layoutGuideColumnMargin: .25,

  designName: '',
  designSize: '',
  designUnit: 'inch',
  designStatus: 'draft',
  designColors: [],
  designCustomWidth: '',
  designCustomHeight: '',
  hasChanges: false,
  lastSavedTag: '',
  lastSaved: new Date().getTime(),
  lastUpdate: new Date().getTime(),
  customWidth: '',
  customHeight: '',
  customUnit: '',
  free: false,

  borderBottomColor: '#000000',
  borderBottomWidth: 0,

  isSocialDesign: false,
  isBusinessCard: false,
  isLoyaltyCard: false,
  isCommentCard: false,
  isRackCard: false,
  isGiftCertificate: false,
  isTakeout: false,
  isFoldedMenu: false,
  isHalfPageMenu: false,
  isTableTent: false,
  isTableTentInsert: false,
  isFacebookPost: false,
  isFacebookStory: false,
  isInstagramPost: false,
  isInstagramStory: false,
  isPoster: false,
  isDigitalMenuBoard: false,
  isSticker: false,
  isLabel: false,
  isSandwichBoard: false,
  isCustomSize: false,

  isLogo: false,
  isPixelDesign: false,

  hasSelection: false,
  isSafetyZoneToggled: true,
  isTextHighlight: false,
  isMultiSelect: false,
  multiSelectType: 'none',
  isInGroup: false,
  selectionType: 1,
  $element: null,
  $elements: [],
  illustrationConfig: {},
  MOEditMode: 'items',

  shapeType: 'line',
  width: 0,
  height: 0,

  isBold: false,
  isItalic: false,
  isUnderline: false,
  isUppercase: false,

  fontFamily: '',
  fontFamilyKey: '',
  fontSize: '',
  color: '',
  textAlign: 'left',
  opacity: 100,
  brightness: 100,
  contrast: 100,
  vibrance: 100,
  saturation: 100,
  blur: 0,
  grayscale: 0,
  sepia: 0,
  invert: 0,
  muted: false,
  animation: '',

  backgroundColor: '',
  backgroundColorOpacity: 100,

  moNameBackgroundRadius: 0,
  moNameBackgroundColor: '',
  moNameBackgroundOpacity: 100,
  moNameLineColor: '',
  moNameLineWidth: 0,
  moNameBorderColor: '',
  moNameBorderWidth: 0,
  moNotesLineColor: '',
  moNotesLineWidth: 0,

  numColumns: 1,
  columnWidths: [],
  columnGap: 0,

  letterSpacing: '0',
  lineHeight: '0',
  textWrapped: false,
  curveValue: '1',
  textShadowed: false,
  padding: '0',
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '0',
  paddingRight: '0',

  bgColor: '',
  bgOpacity: '',

  isCtrlPressed: false,
  isShiftPressed: false,

  borderRadius: 0,
  borderColor: '#000000',
  borderWidth: 0,

  zoom: 100,
  zoomAdjusted: 100,
  minZoom: 10,
  maxZoom: 280,

  view: 'templates',
  subview: 'root',

  isPromosVisible: false,

  strokeColor: '#000000',
  fillType: 'solid',
  fillColor: 'none',
  strokeWeight: 1,

  promoDesignsLoading: true,
  promoDesigns: [],

  publicPromoDesigns: [],
  templateGroups: [],
  templateFamilies: [],
  templateView: 'group',
  selectedFamily: '',
  selectedCollection: '',
  selectedCategory: '',

  isRulerVisible: false,
  isLayoutGuideToggled: false,

  hasHistoryNext: false,
  hasHistoryPrev: false,

  scale: 100,
  rotationDeg: 0,
  verticalFlip: false,
  horizontalFlip: false,

  selectedMultiAligned: '',

  isFrame: false,
  isImage: false,
  isVideoFrame: false,
  isShape: false,
  isLine: false,
  isIllustration: false,
  preserveRatio: true,

  isVersionPreview: false,
  previewId: '',
  revisionLabel: '',

  draftCount: 0,
  submittedCount: 0,
  reviewedCount: 0,
  rejectedCount: 0,
  publishedCount: 0,
  samplecopyCount: 0,
  restoreHardCount: 0,
  restoreEasyCount: 0,

  fixImagePath: '',
  isAuthOverlay: false,
  isFixImageModal: false,
  isConfigureTemplateModal: false,
  isConfigureIllustrationModal: false,
  isMoveCopyTemplateModal: false,
  isMenuContentModal: false,
  isSharingModal: false,
  isCollectionModal: false,
  isImportWebsiteModal: false,
  isAltTextModal: false,
  isOrganizeUploadsModal: false,
  selectedUploadedImage: null,
  selectedUploadedIcon: null,
  isJustUploaded: false,

  downloadPdfWithBleeds: false,

  authOverlayView: 'reg',
  authOverlayExit: false,

  statusFilter: '',

  showExitWarning: true,

  selectionIndex: 0,
  selectionLength: 0,

  menuObjectItems: [],
  isMenuObjectCopied: false,
  menuObjectStyles: {},
  menuObjectDots: false,
  menuObjectLayout: 'stacked',
  iconLayout: 'icon-right',
  iconsInDescription: false,
  iconPosition: 'name',
  showMenuTag: false,
  showModifiers: false,
  modifierLayout: 'in-line',
  modifierDivider: '',
  hidePrices: false,
  hideTrailingZeroes: false,
  inlineExtras: false,
  menuTagLayout: '',
  priceDivider: '',
  menuObjectImportLocation: -1,
  menuObjectImportDesign: null,

  isLocked: false,
  isHyperlink: false,
  href: '',
  isDesignLoading: false,

  websiteToken: '',
  shareLink: null,
  inSync: false,
  isSyncing: false,
  isSyncingQR: false,
  isPublishing: false,
  copyButtonText: 'Copy',

  isMobileVersion: false,

  isReplaceFrameMode: false,
  isQRDesignMode: false,
  isAddQRMode: false,

  accents: '',

  printAdvisor: {
    enabled: false,
    step: 1,
    addToCartURL: null,
    isProductInCart: false,
    allowPrint: false
  },

  printPaperType: '',
  printPagination: '',
  printQuantity: '',

  posFeature: false,
  toastEmail: "",
  isSquare: false,
  isTreez: false,
  isPopmenu: false,

  colorPickerType: constants.pickerTypes.backgroundFill,
  prevAsideView: '',
  isLeftMenuVisible: true,

  iniFrame: false,
  hasVideo: false,
  hasAnimation: false,

  menuGroups: [],
  menuGroupsSource: "",
  menuGroupsSourceInProgress: false,
  applyToMoInProgress: false,
  itemLibraryDefaultView: '',

  menuActiveIcons: [],
  isDSADesign: false,

  mainNotificationMessage: "",

  seoRestaurantName: "",
  seoMenuAdjective: "",
  seoFoodType: "",
  seoCity: "",
  seoState: "",
  seoShareLinkError: "",
  seoExampleTitle: "",
  seoExampleText: "",

  posAutoSyncEnabled: false,
  dsaAutoSyncEnabled: false,
  linksAutoSyncEnabled: false,
  posSyncPendingCount: 0,
  hasPosData: false,

  isMobileAside: false,
  isMobileBottomNav: true,
  isViewAllPages: false,

  lastSelectedHighlightId: '',
  favoriteAssets: [],
};

const enhancer = applyMiddleware(thunk);
export default createStore(
  (state, action) => (
    action && ACTIONS[action.type] ? ACTIONS[action.type](state, action) : state
  ),
  INITIAL,
  enhancer
)
